import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RetailerComponent } from './retailer/retailer.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';

@NgModule({
  declarations: [RetailerComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatInputModule,
    MatSelectModule,
    NgbDatepickerModule
  ],
  exports: [RetailerComponent]
})
export class InvoiceModule { }
